import { inject } from '@angular/core';
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';

export const signupGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const currentRoute = inject(ActivatedRoute); 

  // Replace this with your actual logic (e.g., checking for an ID, token, or state)
  var mobileNumber = sessionStorage.getItem("mobileNumber")

  if (mobileNumber != null) {
    return true; // Allow navigation to the target page
  } else {
    const currentUrlSegments = state.url.split('/'); 
    currentUrlSegments.pop(); // Remove 'target-page'
    currentUrlSegments.push('login'); // Add 'login'
    
    const fallbackPath = currentUrlSegments.join('/');
    return router.parseUrl(fallbackPath);
  }
};